<template functional>
    <div class="form-row tw-flex tw-flex-col tw-items-start tw-mb-4 md:tw-grid md:tw-gap-x-4 md:tw-mb-7 md:tw-ml-0"
         :class="['tw-grid-cols-' + props.fields, data.class, data.staticClass]">
        <!--<div class="form-row mb-7" :class="['col-' + props.fields, data.class, data.staticClass]">-->
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'FormRow',
        props: {
            fields: {
                default: 1,
            },
        },
    };
</script>

<style lang="scss">
    .form-row {
        &.grid-cols-2 {
            .form-field:last-of-type {
                @apply tw-mt-4;

                @screen md {
                    @apply tw-mt-0;
                }
            }
        }

        &.mb-0 {
            @apply tw-mb-0;
        }
    }
</style>
